import React, { useState, useEffect } from 'react';
    import { Link } from 'react-router-dom';
    import { ArrowRight } from 'lucide-react';
    import { getAllProducts } from '../../data/productData';
    import ProductCardSkeleton from '../common/ProductCardSkeleton';

    const FeaturedProducts = () => {
      const [featuredProducts, setFeaturedProducts] = useState([]);
      const [isLoading, setIsLoading] = useState(true);

      useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
          try {
            const allProducts = getAllProducts();
            const getRandomProducts = (products, count = 3) => {
              const shuffled = [...products].sort(() => 0.5 - Math.random());
              return shuffled.slice(0, count);
            };
            setFeaturedProducts(getRandomProducts(allProducts, 3));
          } catch (error) {
            console.error("Failed to load featured products:", error);
          } finally {
            setIsLoading(false);
          }
        }, 800); // Simulate load time

        return () => clearTimeout(timer);
      }, []);

      return (
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Featured Products
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Discover our most advanced membrane solutions designed for superior water treatment performance
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {isLoading
                ? Array.from({ length: 3 }).map((_, index) => (
                    <ProductCardSkeleton key={index} />
                  ))
                : featuredProducts.map((product) => (
                    <Link
                      key={product.id}
                      to={`/products/${product.id}`}
                      className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group block"
                    >
                      <div className="relative">
                        <img
                          src={product.image}
                          alt={product.name}
                          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute top-4 right-4">
                          <span className="bg-white text-gray-800 px-3 py-1 rounded-full text-sm font-medium shadow-sm">
                            {product.category}
                          </span>
                        </div>
                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                          {product.name}
                        </h3>
                        <p className="text-gray-600 mb-4">
                          {product.shortDescription}
                        </p>
                        <div className="space-y-2 mb-6">
                          {product.features.slice(0, 3).map((feature, index) => (
                            <div key={index} className="flex items-center text-sm text-gray-500">
                              <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-2"></div>
                              {feature}
                            </div>
                          ))}
                        </div>
                        <div className="inline-flex items-center text-blue-600 font-medium group-hover:text-blue-800 transition-colors group-hover:translate-x-1 transform duration-200">
                          Learn More
                          <ArrowRight className="w-4 h-4 ml-2" />
                        </div>
                      </div>
                    </Link>
                  ))}
            </div>
            <div className="text-center mt-12">
              <Link
                to="/products"
                className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200"
              >
                View All Products
                <ArrowRight className="w-5 h-5 ml-2" />
              </Link>
            </div>
          </div>
        </section>
      );
    };

    export default FeaturedProducts;